import { IGetCorrectionsResponseType } from '@/api/corrections/type'
import useAuthStore from '@/store/useAuthStore'
import { Alert, Button } from '@dgshahr/ui-kit'
import { useNavigate } from 'react-router-dom'

type Props = {
  data: IGetCorrectionsResponseType
}

const ApprovedStatus = ({ data }: Props) => {
  const navigate = useNavigate()
  const { clearAuth } = useAuthStore()

  const handleClick = () => {
    clearAuth()
    navigate('/')
  }

  return (
    <div className="w-[500px] h-[270px] flex flex-col justify-around p-4 border rounded-xl bg-white">
      <div>
        <p className="text-xl pb-4">
          <span>{data?.full_name}</span> -{' '}
          {data?.is_individual ? 'حقیقی' : 'حقوقی'}
        </p>
        <Alert
          showTitleIcon
          variant="success"
          text="با درخواست شما برای فروش در آپولون موافقت شد. برای تنظیم قرارداد با شما تماس گرفته خواهد شد."
        />
      </div>
      <Button isFullWidth color="error" variant="outline" onClick={handleClick}>
        خروج از حساب کاربری
      </Button>
    </div>
  )
}

export default ApprovedStatus
